<template>
  <div class="system-builder__select-system--container">
    <div class="system-builder__select-system--item">
      <img :src="sharedState.customFields.remote_start_image.url"
           :alt="sharedState.customFields.remote_start_image.alt" v-if="sharedState.customFields.remote_start_image">
      <strong>{{sharedState.customFields.remote_start_title}}</strong>
      <div v-html="sharedState.customFields.remote_start_description"></div>
      <button class="button__solid--blue" @click="saveSelectedSystem('START IT')">Select</button>
    </div>

    <div class="system-builder__select-system--item">
      <img :src="sharedState.customFields.security_image.url" :alt="sharedState.customFields.security_image.alt" v-if="sharedState.customFields.security_image">
      <strong>{{sharedState.customFields.security_title}}</strong>
      <div v-html="sharedState.customFields.security_description"></div>
      <button class="button__solid--blue" @click="saveSelectedSystem('ALARM IT')">Select</button>
    </div>

    <div class="system-builder__select-system--item">
      <img :src="sharedState.customFields.remote_start_security_image.url"
           :alt="sharedState.customFields.remote_start_security_image.alt" v-if="sharedState.customFields.remote_start_security_image">
      <strong>{{sharedState.customFields.remote_start_security_title}}</strong>
      <div v-html="sharedState.customFields.remote_start_security_description"></div>
      <button class="button__solid--blue" @click="saveSelectedSystem('MAX IT')">Select</button>
    </div>
  </div>
</template>

<script>
  import store from '../../store/index'
  import router from '../../router'
  import spinner from 'vue-simple-spinner'

  export default {
    components: {spinner},
    name: 'selectSystem',
    data () {
      return {
        sharedState: store.state
      }
    },
    methods: {
      saveSelectedSystem: function (selectedSystem) {
        // Save selected system in store
        store.holdSelectedSystem(selectedSystem)

        // Create system string and store in state
        var systemCatString = ''

        if (selectedSystem === 'START IT') {
          systemCatString = 'Universal Remote Start System'
        } else if (selectedSystem === 'ALARM IT') {
          systemCatString = 'Universal Security System'
        } else if (selectedSystem === 'MAX IT') {
          systemCatString = 'Universal Remote Start & Security System'
        }

        var systemString = systemCatString
        store.updateSystemStringState(systemString)

        // Navigate to remote selection
        store.updateCurrentStateRoute('selectCommunication')
        router.push({name: 'selectCommunicationType'})
      }
    },
    mounted: function () {
      if (store.state.vehicleObject.year === 'Vehicle Year') {
        store.updateCurrentStateRoute('selectVehicle')
        router.push({name: 'selectVehicle'})
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SelectSystem.vue?1677a1bd